import { isAuthenticating } from "@/libraries/helper";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/account")({
	beforeLoad: async () => {
		if (!isAuthenticating()) {
			throw redirect({
				to: "/",
				replace: true,
			});
		}
		throw redirect({
			to: "/dashboard/accounts",
			replace: true,
		});
	},
});
